var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgActiveFilter = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 18,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.5 13.5H10.5V12H7.5V13.5V13.5ZM2.25 4.5V6H15.75V4.5H2.25V4.5ZM4.5 9.75H13.5V8.25H4.5V9.75V9.75Z",
  fill: "#2E2E38"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 14,
  cy: 4,
  r: 3.5,
  fill: "#155CB4",
  stroke: "white"
})));
export { SvgActiveFilter as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03LjUgMTMuNUgxMC41VjEySDcuNVYxMy41VjEzLjVaTTIuMjUgNC41VjZIMTUuNzVWNC41SDIuMjVWNC41Wk00LjUgOS43NUgxMy41VjguMjVINC41VjkuNzVWOS43NVoiIGZpbGw9IiMyRTJFMzgiLz4KPGNpcmNsZSBjeD0iMTQiIGN5PSI0IiByPSIzLjUiIGZpbGw9IiMxNTVDQjQiIHN0cm9rZT0id2hpdGUiLz4KPC9zdmc+Cg==";